import { responseSchema } from '@/core/types/Response.ts'
import { z } from 'zod'
import { assignDeviceToClientSchema } from '@/modules/sales/clients/types/AssignDeviceToClient.ts'

export const assignDeviceToClientResponseSchema = responseSchema(
  assignDeviceToClientSchema
)

export type AssignDeviceToClientResponse = z.infer<
  typeof assignDeviceToClientResponseSchema
>
